var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main"},_vm._l((_vm.drillModules),function(drillModule){return _c(drillModule,{tag:"component"})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }